import { useQuery, type UseQueryOptions } from 'react-query';

import { type ListAreaReportDto } from '@plot/plot-api';

import { useApi } from '@/lib/api';
import { useAuth, useLocale } from '@/lib/contexts';

export type ReportsQueryParams = {
  workspaceId?: string;
};

export function useReports(
  { workspaceId }: ReportsQueryParams = {},
  options: Omit<
    UseQueryOptions<ListAreaReportDto | undefined>,
    'queryKey' | 'queryFn'
  > = {}
) {
  const { api } = useApi();
  const { authenticated, token } = useAuth();
  const { locale } = useLocale();

  return useQuery(
    ['area-reports', workspaceId, authenticated, token?.access, locale],
    async () => {
      if (!authenticated) return undefined;

      if (!workspaceId) return undefined;

      return api.workspace.areaReport.list(workspaceId);
    },
    options
  );
}
